import React from 'react';
import { Box } from '@mui/material';
import { LogoMark, Mono, useModeTokens } from '@/common/components/ui';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Download stays in a dialog because `/download` is an authenticated route.
 * Legal links are ordinary public routes so they remain accessible before and
 * after sign-in.
 */
export const LandingFooter: React.FC<{ onDownload: () => void }> = ({
  onDownload,
}) => {
  const t = useModeTokens();

  return (
    <Box
      component="footer"
      className="lp-gloss-footer"
      sx={{
        padding: { xs: '26px 20px 30px', md: '32px 40px 34px' },
        borderTop: `1px solid ${t.borders.divider}`,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '16px 30px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
        <LogoMark size={22} showWordmark={false} />
        <Mono size={11}>© {new Date().getFullYear()} STUDIOVAULT</Mono>
      </Box>
      <Box
        sx={{
          marginLeft: 'auto',
          display: 'flex',
          gap: '22px',
          fontSize: '12.5px',
        }}
      >
        <Box
          component="button"
          type="button"
          onClick={onDownload}
          sx={{
            background: 'none',
            border: 0,
            padding: 0,
            fontFamily: 'inherit',
            fontSize: 'inherit',
            cursor: 'pointer',
            color: t.text.muted,
            '&:hover': { color: t.text.primary },
          }}
        >
          Download
        </Box>
        <Box
          component={RouterLink}
          to="/privacy"
          sx={{
            color: t.text.muted,
            textDecoration: 'none',
            '&:hover': { color: t.text.primary },
          }}
        >
          Privacy
        </Box>
        <Box
          component={RouterLink}
          to="/terms"
          sx={{
            color: t.text.muted,
            textDecoration: 'none',
            '&:hover': { color: t.text.primary },
          }}
        >
          Terms
        </Box>
      </Box>
    </Box>
  );
};

export default LandingFooter;
